export enum BodyBackdropActions {
  REMOVE_BODY_BACKDROP = 'REMOVE_BODY_BACKDROP',
  SET_BODY_BACKDROP = 'SET_BODY_BACKDROP',
}
